"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ParsePropsError_1 = require("../errors/ParsePropsError");
const ParseResult_1 = require("../ParseResult");
exports.failedParseProps = (errors, key) => {
    const error = {
        type: ParsePropsError_1.ParsePropsErrorType,
        key: key,
        errors: errors,
    };
    return {
        type: ParseResult_1.FailedParseResultType,
        error: error,
    };
};
//# sourceMappingURL=failedParseProps.js.map